//引入axios
import axios from 'axios'
import Cookies from "js-cookie";
import {
    router
} from '../router/index.js'
import store from '../store'
import util from "./util"
import { Message } from 'iview';
axios.defaults.baseURL = ajaxUrl;
//超时请求
axios.defaults.timeout = 1000000;
// 请求拦截器
axios.interceptors.request.use(config => {
    let IsGlobalEncryptDecryp = localStorage.getItem("IsGlobalEncryptDecryp");
    if (JSON.parse(IsGlobalEncryptDecryp)) {
        if (config.data instanceof FormData) {
            return config;
        } else{
            let message = "";
            if (config.data) {
                message = config.data;
            }
            if (config.params) {
                message = config.params;
            }
            if (message) {
                config.data = util.encryptByECB(message,store.state.app.secretKey);
            }
            return config;
        }
    } else{
        return config;
    }
})
//响应拦截器即异常处理
axios.interceptors.response.use(response => {
    if(response.headers.refresh_code){
        app.setHeader(response.headers.refresh_code);
    }
    let IsGlobalEncryptDecryp = localStorage.getItem("IsGlobalEncryptDecryp");
    if (JSON.parse(IsGlobalEncryptDecryp)) {
        response.data = util.decryptByECB(response.data.result,store.state.app.secretKey);
    }
    return response
}, err => {
    store.commit('changeConect', false);
    if (err && err.response) {
        app.error(err.response.status);
    } else {
        err.message = "连接到服务器失败"
    }
    return Promise.reject(err.response);
});

const app = {

    //get请求
    get(url, param) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'get',
                url,
                params: param,
                headers: {
                    "auth_code": localStorage.getItem("auth_code"),
                    "X-Tenant": localStorage.getItem("tenantId")?localStorage.getItem("tenantId"):""
                }
            }).then(res => {
                this.error(res.data.code);
                resolve(res)
            })
        })
    },
    //post请求
    post(url, param ,type) { //type 区别传参格式是param还是data
        let postObj={
            method: 'post',
            url,
            data: param,
            headers: {
                "auth_code": localStorage.getItem("auth_code"),
                "X-Tenant": localStorage.getItem("tenantId")?localStorage.getItem("tenantId"):""
            }
        }
        if(type){
            postObj={
                method: 'post',
                url,
                params:param,
                headers: {
                    "auth_code": localStorage.getItem("auth_code"),
                    "X-Tenant": localStorage.getItem("tenantId")?localStorage.getItem("tenantId"):""
                }
            }
        }
        return new Promise((resolve, reject) => {
            axios(postObj).then(res => {
                this.error(res.data.code);
                resolve(res);
            }).catch((res) => {
                // this.error(res.data.status);
                //console.log(res)
            })
        })
    },
    // deleted
    delete(url,config) {

        return new Promise((resolve, reject) => {
            axios({
                ...config,
                method: 'delete',
                url,
                headers: {
                    "auth_code": localStorage.getItem("auth_code"),
                    "X-Tenant": localStorage.getItem("tenantId")?localStorage.getItem("tenantId"):""
                }
            }).then(res => {
                this.error(res.data.code);
                resolve(res)
            })
        })
    },
    getFiles(url, params, fileName) {
        fileName = fileName || "";
        return new Promise((resolve, reject) => {
            axios.get(url, {
                headers: {
                    "auth_code": localStorage.getItem("auth_code"),
                    "X-Tenant": localStorage.getItem("tenantId")?localStorage.getItem("tenantId"):""
                },
                params: params,
                responseType: 'blob',
            }).then(res => {
                if (res.headers["content-type"] == "application/json;charset=UTF-8") {
                    store.commit("changeShowLoading", { status: false, text: "" });
                    res.data.text().then(errorMessage => {
                        let data = JSON.parse(errorMessage);
                        Message.error(data.msg);
                    });
                    return
                }
                let responseURL = res.request.responseURL.split(';')
                if (responseURL.length>=2) {
                    let error = responseURL[0].split('/')
                    if (error[3] == "error" && error[4] == "unauthenticated") {
                        this.error(3)
                        resolve(res);
                        return
                    }
                }
                let url = window.URL.createObjectURL(res.data);
                let link = document.createElement('a');
                link.style.display = 'none';
                link.href = url;
                link.setAttribute('download',fileName);
                document.body.appendChild(link);
                link.click();
                resolve(res);
            }).catch(err => {
                reject(err)
            })
        })
    },
    postFiles(url, params, fileName = "") {
        return new Promise((resolve, reject) => {
            axios({
                method: 'post',
                url: url,
                data: params,
                headers: {
                    "auth_code": localStorage.getItem("auth_code"),
                    "X-Tenant": localStorage.getItem("tenantId") || ""
                },
                responseType: 'blob' // 设置为 blob 以处理文件下载
            }).then(res => {
                if (res.headers["content-type"] == "application/json;charset=UTF-8") {
                    store.commit("changeShowLoading", { status: false, text: "" });
                    res.data.text().then(errorMessage => {
                        let data = JSON.parse(errorMessage);
                        Message.error(data.msg);
                    });
                    return
                }
                let responseURL = res.request.responseURL.split(';')
                if (responseURL.length>=2) {
                    let error = responseURL[0].split('/')
                    if (error[3] == "error" && error[4] == "unauthenticated") {
                        this.error(3)
                        resolve(res);
                        return
                    }
                }
                let url = window.URL.createObjectURL(res.data);
                let link = document.createElement('a');
                link.style.display = 'none';
                link.href = url;
                link.setAttribute('download',fileName);
                document.body.appendChild(link);
                link.click();
                resolve(res);
            }).catch(err => {
                reject(err);
            });
        });
    },
    // 获取参数配置的通用接口
    getSourceAndValue(data){
        return new Promise((resolve,reject) => {
            axios({
                method: 'post',
                url:'/config ',
                headers: {
                    "auth_code": localStorage.getItem("auth_code"),
                    "X-Tenant": localStorage.getItem("tenantId")?localStorage.getItem("tenantId"):""
                },
                data
            }).then(res => {
                this.error(res.data.code);
                resolve(res)
            })
        })
    },
    // 更新参数配置通用接口
    updateByPNo(data){
        return new Promise((resolve,reject) => {
            axios({
                method: 'post',
                url:'/paramSystem/updateConfig',
                headers: {
                    "auth_code": localStorage.getItem("auth_code"),
                    "X-Tenant": localStorage.getItem("tenantId")?localStorage.getItem("tenantId"):""
                },
                data
            }).then(res => {
                this.error(res.data.code);
                resolve(res)
            })
        })
    },
    setHeader(authCode) {

        localStorage.removeItem("auth_code");
        localStorage.setItem("auth_code", authCode);
    },
    //通知客户端刷新
    sendNotice(data) {
        return new Promise((resolve, reject) => {
        axios({
            method: "post",
            url: "/mqtt/controlByFree",
            headers: {
                auth_code: localStorage.getItem("auth_code"),
                "X-Tenant": localStorage.getItem("tenantId")?localStorage.getItem("tenantId"):""
            },
            data
        }).then(res => {
            this.error(res.data.code);
            resolve(res);
        });
        });
    },
    error(status) {
        // router.replace({
        //     path: '/error-404'
        // });
        switch (status) {
            //请求没有权限状态码
            case 2:
                router.replace({
                    path: '/error-403'
                });
                break;
                //请求未登录状态码
            case 3:
                Cookies.remove('user');
                router.replace({
                    path: '/login'
                });
                break;
                //请求未找到
            case 404:
                // router.replace({
                //     path: '/error-404'
                // });
                break;

        }
    }


}
export default app;



// WEBPACK FOOTER //
// ./src/libs/ajax.js